import React, { useContext, useState } from "react";
import {
  IconSearch,
  IconSettings,
  IconPlus,
  IconChevronLeft,
  IconChevronRight,
  IconCalendar,
  IconAlertTriangle,
} from "@tabler/icons-react"; // Import Tabler Icons
import LayoutDashboard from "layouts/layout-dashboard-collapse"; // Assuming this is a layout component
import { useApp } from "contexts/BookingContext"; // Import AppContext
import SessionBlock from "./components/SessionBlock";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import CreatePage from "./components/create-page";
import DateInputWithIcon from "./components/DateInputWithIcon";

const BookingApp = () => {
  const { sessions, setIsOpenCanvas } = useApp();
  const { handleSuccess, handleError, showCanvasHandler } = useCanvasHandler();
  const handleCreate = (e) => {
    e.preventDefault();
    showCanvasHandler(
      "Create Reservation",
      <CreatePage onSuccess={handleSuccess} onError={handleError} />
    );
  };
  return (
    <LayoutDashboard>
      {/* Header */}
      <div className="">
        {/* alert */}
        {/* <div className="mx-4 my-4 alert alert-warning alert-dismissible" role="alert">
          <div className="d-flex">

            <div className="me-3">
              <IconAlertTriangle size={24} />
            </div>


            <div>
              <strong>Info! </strong>Terdapat waiting booking yang belum
              diproses.
            </div>
          </div>


          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="alert"
            aria-label="Close"
          ></button>
        </div> */}

        <div className="row g-2 w-100 m-3 d-flex">
          {/* Button Create Booking */}
          <div className="col-md-8 d-flex row">
            <div className="col-md-3">
              <button className="btn btn-primary w-100" onClick={handleCreate}>
                <IconPlus size={18} className="me-2" />
                <span>Booking</span>
              </button>
            </div>

            {/* Button Quick Booking */}
            <div className="col-md-3">
              <button className="btn btn-dark w-100">
                <IconPlus size={18} className="me-2" />
                <span>Quick</span>
              </button>
            </div>
            <div className="col">
              <input
                type="text"
                placeholder="Search"
                className="form-control w-100"
              />
            </div>

            {/* Search Input */}

            {/* Waiting Booking Button */}
            {/* <div className="col">
              <button className="btn w-100 btn-warning">
                <span>Waiting</span>
              </button>
            </div> */}
          </div>
          <div className="col-md-4 d-flex row align-self-end">
            
            <div className="col-md-6 text-end">
              <DateInputWithIcon />
            </div>
            <div className="col-md-6">
              <div className="btn-group d-flex">
                <button className="btn">
                  <IconChevronLeft size={18} />
                </button>
                <button className="btn">
                  <IconChevronRight size={18} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Sessions Grid (Placeholder) */}
      <div className="p-4 rounded-lg bg-white">
        {/* You can insert session-related content here */}
        {sessions.map((session, index) => (
          <SessionBlock key={session.id} session={session} />
        ))}
      </div>
    </LayoutDashboard>
  );
};

export default BookingApp;
